var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChatComponent',{attrs:{"current-user-id":_vm.user.id,"rooms":_vm.rooms,"rooms-loaded":_vm.roomsLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }